<app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>

<div class="container">
    <div class="row top-margin">
        <div class="col-sm-12 text-center" *ngIf="!addMode">
            <button class="btn btn-info" (click)="allowToAdd()">+ Add a User</button>
        </div>
    </div>

    <form (ngSubmit)="onAddDavener(f.value)" #f="ngForm">
        <div class="row top-margin" *ngIf="addMode">
            <div class="col-sm-3">
                <input type="text" id="email" class="form-control" name="email" ngModel placeholder="*Email (required)"
                    email required #email="ngModel">
                <span class="help-block" *ngIf="email.invalid&&email.touched">Valid email required</span>
            </div>
            <div class="col-sm-3"><input type="text" id="whatsapp" class="form-control" name="whatsapp" ngModel
                    placeholder="Whatsapp number (digits only)" pattern="^[0-9]+$" #whatsapp="ngModel">
                <span class="help-block" *ngIf="whatsapp.invalid&&whatsapp.touched">Only digits allowed</span>
            </div>

            <div class="col-sm-2">
                <select id="country" class="form-control" name="country" [ngModel]="'Israel'">
                    <option value="Israel">Israel</option>
                    <!--common countries first - removed from country array -->
                    <option value="USA">USA</option>
                    <option value="Canada">Canada</option>
                    <option *ngFor="let country of daveningService.countries" [value]="country">{{country}}</option>
                </select>
            </div>
            <div class="form-check col-sm-2">
                <input type="checkbox" class="form-check-input" id="activate" name="activate" ngModel>
                <label class="form-check-label" for="myCheckbox">Click to receive weekly lists</label>
            </div>
            <div class="col-sm-2">
                <button class="btn btn-primary" type="submit" [disabled]="!f.valid">Submit</button>
                <!--cancel button-->
                <button type="button" class="btn btn-danger btn-sm" (click)="onCancelAdd(f)">X</button>
            </div>
        </div>
    </form>

    <div class="hr-wrapper" *ngIf="(daveners | filterActive:true)?.length > 0">
        <hr>
        <span style="padding: 0 10px;">ACTIVE USERS</span>
        <hr>
    </div>

    <div class="hidden-scrollbar" *ngIf="daveners&&daveners.length<=0">
        <app-empty-list whatIsMissing="registered emails"></app-empty-list>
        <!--If there are no daveners, display a message-->
    </div>

    <div *ngIf="daveners.length>0">
        <table class="table table-responsive">
            <tr *ngIf="(daveners | filterActive:true)?.length > 0">
                <th class="col-sm-3">Email</th>
                <th class="col-sm-3">Whatsapp
                </th>
                <th class="col-sm-3">Country</th>
            </tr>

            <tr *ngFor="let davener of daveners | filterActive:true">
                <td class="col-sm-3">
                    <div *ngIf="davener.id!=davenerToEdit.id else emailEdit">{{davener.email}}</div>
                </td>
                <td class="col-sm-3">
                    <div *ngIf="davener.id!=davenerToEdit.id else whatsappEdit">
                        {{davener.whatsapp>0?davener.whatsapp:'---'}}</div>
                </td>
                <td class="col-sm-3">
                    <div *ngIf="davener.id!=davenerToEdit.id else countryEdit">{{davener.country}}</div>
                </td>
                <td>
                    <!--Edit button is disabled if someone else is being edited, not him-->
                    <div *ngIf="davener.id!=davenerToEdit.id else toEditButtons"><button class="btn btn-warning "
                            [disabled]="(davenerToEdit.id!=-1)&&(davenerToEdit.id!=davener.id)"
                            (click)="onEdit(davener)">Edit</button>
                        <button class="btn btn-danger" (click)="onDelete(davener)">Delete</button>
                        <!--appropriate deactivate/activate buttons if davener is active or not-->
                        <button class="btn btn-danger" (click)="onDeactivate(davener)">Deactivate</button>
                    </div>
                </td>
            </tr>
        </table>

        <div class="hr-wrapper" *ngIf="(daveners | filterActive:false)?.length > 0">
            <hr>
            <span style="padding: 0 10px;">INACTIVE USERS</span>
            <hr>
        </div>

        <table class="table table-responsive">
            <tr *ngIf="(daveners | filterActive:false)?.length > 0">
                <th class="col-sm-3">Email</th>
                <th class="col-sm-3">Whatsapp
                </th>
                <th class="col-sm-3">Country</th>
            </tr>

            <tr *ngFor="let davener of daveners | filterActive:false">
                <td class="col-sm-3">
                    <div class="inactive" *ngIf="davener.id!=davenerToEdit.id else emailEdit">{{davener.email}}
                        (deactivated)</div>
                </td>
                <td class="col-sm-3">
                    <div class="inactive" *ngIf="davener.id!=davenerToEdit.id else whatsappEdit">
                        {{davener.whatsapp>0?davener.whatsapp:'---'}}
                    </div>
                </td>
                <td class="col-sm-3">
                    <div class="inactive" *ngIf="davener.id!=davenerToEdit.id else countryEdit">{{davener.country}}
                    </div>
                </td>
                <td>
                    <!--Edit button is disabled if someone else is being edited, not him-->
                    <div *ngIf="davener.id!=davenerToEdit.id else toEditButtons"><button class="btn btn-warning"
                            [disabled]="(davenerToEdit.id!=-1)&&(davenerToEdit.id!=davener.id)"
                            (click)="onEdit(davener)">Edit</button>
                        <button class="btn btn-danger" (click)="onDelete(davener)">Delete</button>
                        <!--appropriate deactivate/activate buttons if davener is active or not-->
                        <button class="btn btn-success" (click)="onActivate(davener)">Activate</button>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>

<ng-template #emailEdit>
    <input (keyup)="emailValidator(email)" #email id="emailEdit" type="email" class="form-control" required email
        [(ngModel)]="davenerToEdit.email">
    <span class="help-block" *ngIf="!emailValid">Valid email required</span>
</ng-template>

<ng-template #whatsappEdit>
    <input (keyup)="whatsappValidator(whatsapp)" id="whatsappEdit" #whatsapp name="whatsappEdit" pattern="^[0-9]+$"
        type="text" class="form-control" [(ngModel)]="davenerToEdit.whatsapp">
    <span class="help-block" *ngIf="!whatsappValid">Only digits allowed</span>
</ng-template>

<ng-template #countryEdit>
    <select id="countryEdit" class="form-control" [(ngModel)]="davenerToEdit.country">
        <option value="Israel">Israel</option>
        <!--common countries first - removed from country array -->
        <option value="USA">USA</option>
        <option value="Canada">Canada</option>
        <option *ngFor="let country of daveningService.countries" [value]="country">{{country}}</option>
    </select>
</ng-template>

<ng-template #toEditButtons>
    <button class="btn btn-success" [disabled]="!emailValid||!whatsappValid" (click)="onSendEdit()">Save edit</button>
    <button class="btn btn-danger" (click)="onCancelEdit()">Cancel edit</button>
</ng-template>